module.exports = __webpack_public_path__ + "static/media/20170806_40day_1969AT.b6863483.jpg";